import React, { useEffect, useState } from 'react';

const NoticeLabel = ({ text, addClass }) => {
  return (
    <span
      className={`truncate ml-3 text-xs md:text-sm  bg-[#a085db] px-3 text-center text-[#fff] rounded-2xl xs:py-1 py-0 px-[5px] mr-3 inline-block ${addClass} `}
    >
      {text}
    </span>
  );
};

export default NoticeLabel;
